import Izhevsk from './coordinates/Izhevsk/Izhevsk.json';
import LeninskiyRayon from './coordinates/Izhevsk/Leninskiy rayon.json';

export default {
    regionCode: 'izhevsk',
    serviceAreas: [
        {
            id: 'izhevsk-1',
            include: [
                {
                    name: 'Ижевск',
                    type: 'polygon',
                    coordinates: Izhevsk,
                }
            ],
            exclude: [
                {
                    name: 'Ленинский район',
                    type: 'polygon',
                    coordinates: LeninskiyRayon,
                }
            ],
        },
        {
            id: 'izhevsk-2',
            include: [
                {
                    name: 'Ленинский район',
                    type: 'polygon',
                    coordinates: LeninskiyRayon,
                }
            ],
        },
        {
            id: 'izhevsk-3',
            include: [
                {
                    name: 'Ижевск (расстояние 10км)',
                    type: 'polygon',
                    distance: true,
                    maxDistance: 10,
                    coordinates: Izhevsk,
                }
            ]
        },
        {
            id: 'izhevsk-4',
            include: [
                {
                    name: 'Ижевск (расстояние 30км)',
                    type: 'polygon',
                    distance: true,
                    maxDistance: 30,
                    coordinates: Izhevsk,
                }
            ]
        }
    ]
};
